import { createAsyncThunk } from '@reduxjs/toolkit';
import Api, { FetchParams } from '../../utils/Api';
import { FAILURE_REASON } from '../../constants';

export const finaliseLoyaltyOrder = createAsyncThunk(
  '$finaliseLoyaltyOrder',
  async (reference: string, { rejectWithValue }) => {
    try {
      const packet: FetchParams = {
        method: 'POST',
        path: '/api/v2/online-payments/sales?mode=loyalty',
        body: { reference },
      };
      const response = await Api.fetch(packet);
      return response.data;
    } catch (e) {
      return rejectWithValue({
        e,
        reason: FAILURE_REASON.PAYMENT_FAILED,
      });
    }
  },
);
